// extracted by mini-css-extract-plugin
module.exports = {"frame":"loop-video_frame__2tCNy"};